// extracted by mini-css-extract-plugin
module.exports = {"logoMobile":"Logo_logoMobile__1l-Yz"};